import { mapActions } from 'vuex'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { isEmpty } from 'lodash'
import { success } from '@/utils/alert'

const prepareSave = data => {
  const registration = {...data}
  if (isEmpty(registration.attachment.content)) {
    delete registration.attachment
  }

  registration.birthdate = dateToMysql(registration.birthdate)
  registration.record = dateToMysql(registration.record)

  return registration
}

const prepareShow = data => {
  const registration = {...data}

  registration.birthdate = dateToShow(registration.birthdate)
  registration.record = dateToShow(registration.record)

  return registration
}

export default {
  ...mapActions(['updateUserData']),
  doSave () {
    const registration = prepareSave(this.registration)
    this.$resource.update('me', registration)
      .then(({data}) => {
        this.updateUserData(data)
        success('Seu dados foram alterados com sucesso.')
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doLoad () {
    this.$resource.get('/me')
      .then(({data}) => {
        console.log('oi', data)
        this.registration = prepareShow(data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/record/registration/resources/methods.js